import { createAction } from 'redux-act';
import { IColorPreset } from '../constants/colorPresets';

export const fetchColorPresets = createAction();
export const fetchColorPresetsSuccess = createAction<IColorPreset[]>();
export const fetchColorPresetsFailed = createAction();
